module.exports = __webpack_public_path__ + "img/key.0d7883e2.svg";